module.exports = __webpack_public_path__ + "static/media/sb.38d8b91e.svg";